import { Component, Inject, OnDestroy } from "@angular/core";
import { StateService, TransitionService } from "@uirouter/angular";
import { MatDialog } from "@angular/material/dialog";
import { PersonDataService } from "../../../core/persons.dataservice";
import { ConfirmDialog } from "../../../shared/confirm-dialog.component";
import * as dataCore from "../../../core/datacore";

@Component({
    selector: "crew-person-edit-jobtitle",
    template: require('./person.jobtitle.edit.component.html')
})
export class PersonJobTitleEditComponent implements OnDestroy {

    private unsubribe: Function;
    FromDate: Date;

    constructor(
        @Inject(PersonDataService.Id) private personDataService: PersonDataService,
        @Inject("person") public person: Nema.Crew.Model.Person,
        @Inject("personJobTitle") public personJobTitle: Nema.Crew.Model.PersonJob,
        @Inject("jobTitles") public jobTitles: Nema.Crew.Model.JobType[],
        private stateService: StateService,
        transitionService: TransitionService,
        private dialog: MatDialog,
        @Inject('$log') private $log: ng.ILogService,
        @Inject("isNew") private isNew: boolean) {

        this.FromDate = dataCore.addTimezoneOffset(this.personJobTitle.FromDate);

        this.cleanUpSubscription();

        this.unsubribe = transitionService.onBefore({}, transition => {

            var hasChanges = this.personDataService.hasChanges();
            if (hasChanges) {

                let dialogRef = this.dialog.open(ConfirmDialog);

                dialogRef.componentInstance.content = "There are unsaved changes, do you want to continue?";
                dialogRef
                    .afterClosed()
                    .subscribe(res => {
                        if (res) {
                            this.rejectChanges();
                            transition.run();
                        }
                    });

                return false;
            }

            return true;
        });
    }

    public entityDisplayName = "Person Job Titles";

    public listStateName = "app.resources.persons.detail";

    private cleanUpSubscription() {
        if (this.unsubribe) {
            this.unsubribe();
            this.unsubribe = null;
        }
    }

    public ngOnDestroy() {
        this.cleanUpSubscription();
    }

    public save() {

        if (this.isNew) {
            this.personJobTitle = this.personDataService.newPersonJobTitle(this.person.Id, this.personJobTitle.JobTypeId);
        }

        this.personJobTitle.FromDate = dataCore.subtractTimezoneOffset(this.FromDate);

        this.personDataService
            .save(this.personJobTitle.Person)
            .then(() => {
                this.$log.info("Successfully saved " + this.entityDisplayName);
                this.backToList();
            })
            .catch(err => this.$log.error("Could not save " + this.entityDisplayName + ", error occured: " + err));
    }

    private rejectChanges() {
        this.personDataService.rejectChanges();
    }

    public cancel() {
        this.rejectChanges();
        this.backToList();
    }

    public backToList(): void {
        this.stateService.go(this.listStateName, { id: this.personJobTitle.PersonId });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/jobtitles/person.jobtitle.edit.component.ts